// extracted by mini-css-extract-plugin
export default {"user_status_icon":"styles_user_status_icon__001Jq","user_check_icon":"styles_user_check_icon__DStQn","user_double_check_icon":"styles_user_double_check_icon__4l7fg"};